import * as outbox from "./outbox";

const API_CACHE = "liftquest-api";

/** The service worker only exists in production builds (and needs HTTPS or localhost). */
export function registerServiceWorker() {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

/** Drops the API responses the service worker kept for offline use – on sign-in, so no other account's data shows up. */
export async function clearApiCache() {
  try {
    if ("caches" in window) await caches.delete(API_CACHE);
  } catch {
    // not available (insecure context)
  }
}

/** Sign-out / account deletion: cached responses and queued sets. */
export async function clearOfflineData() {
  outbox.clearAll();
  await clearApiCache();
}
